import React, { useEffect, useContext, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
// import StockReport from "./StockReport";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  getSystemSettings,
  formatPrice,
  toastObj,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { SettingsContext } from "../../../../../contexts/Settings";

const GoodsReceivedNote = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const { roundOffStock, qtyAmountPoints } = useCustomHooks();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    branchForListSearch,
    getIngredientItem,
    ingredientItemNonPurchase,
    dataPaginating,
    setDataPaginating
  } = useContext(RestaurantContext);
  let { getSupplier, supplierForSearch } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext);

  // States hook here
  //new item
  let [newItem, setNewItem] = useState({
    date: new Date(),
    gr_no: "",
    branch: null,
    is_ref_no: 0,
    supplier: null,
    purchase_order: null,
    description: "",
    manual_invoice_no: "",
    edit: false,
  });
  const [purchaseOrders, setPurchaseOrders] = useState([])
  //new Row
  const [newRow, setNewRow] = useState([]);

  //useEffect == componentDidMount()
  useEffect(() => {
    if (!supplierForSearch) {
      getSupplier();
    }
    if (!ingredientItemNonPurchase) {
      getIngredientItem();
    }
  }, []);

  const setPurchaseOrderItem = (data) => {
    setNewItem({
      ...newItem, purchase_order: data,
      ...(data?.supplier_id && { supplier: { id: data?.supplier_id, name: data?.supplier_name } })
    });
    if (data) {
      if (data?.purchase_order_detail && data.purchase_order_detail.length > 0) {
        let slugArr = [];
        data.purchase_order_detail.map((item) => {
          slugArr.push({
            ...item,
            po_qty: item?.pending_qty || "",
            qty: (Number(item.qty) > Number(item?.pending_qty)) ? item?.pending_qty : item?.qty,
            skip_item: 0,
            tax_percent: item?.tax_percent !== undefined && item?.tax_percent !== null ? roundOffStock(item?.tax_percent) : (item?.gst_tax !== undefined && item?.gst_tax !== null ? roundOffStock(item?.gst_tax) : ""),
            tax: item?.tax !== undefined && item?.tax !== null ? roundOffStock(item?.tax) : (item?.tax_amount !== undefined && item?.tax_amount !== null ? roundOffStock(item?.tax_amount) : ""),
            isEdit: true,
          })
        })
        setNewRow([...slugArr]);
      }
    } else {
      setNewRow([]);
    }
  }

  //get purchase order
  const handlePurchaseOrder = async (branch_id) => {
    const url = BASE_URL + "/settings/get-po-items/" + branch_id;
    try {
      setDataPaginating(true)
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
      if (res.data) {
        setNewRow([]);
        setPurchaseOrders(res.data)
      }
      setDataPaginating(false);
    } catch {
      setDataPaginating(false);
    }
  }

  const getPurchasedItem = async () => {
    const url = BASE_URL + "/settings/goods-received-note/" + parseInt(id);
    setLoading(true)
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
      if (res.data) {
        const editNotes = res.data;
        if (editNotes) {
          let docDate = new Date(editNotes.document_date);
          let branch = branchForListSearch[editNotes.branch_id];
          let suppAcc = supplierForSearch?.find((item) => editNotes.supplier_id === item.id)
          setNewItem({
            ...newItem,
            date: docDate,
            is_ref_no: editNotes.ref_document_identity ? 1 : 0,
            gr_no: editNotes.document_identity,
            manual_invoice_no: editNotes?.manual_invoice_no ?? "",
            branch,
            supplier: suppAcc,
            purchase_order: { id: null, document_identity: editNotes.ref_document_identity },
            description: editNotes.desc,
          })
          let rowArr = [];
          if (editNotes.goods_received_note_detail && editNotes.goods_received_note_detail.length > 0) {
            editNotes.goods_received_note_detail.map((item) => {
              rowArr.push({
                ...item,
                tax_percent: item?.tax_percent !== undefined && item?.tax_percent !== null ? roundOffStock(item?.tax_percent) : (item?.gst_tax !== undefined && item?.gst_tax !== null ? roundOffStock(item?.gst_tax) : ""),
                tax: item?.tax !== undefined && item?.tax !== null ? roundOffStock(item?.tax) : (item?.tax_amount !== undefined && item?.tax_amount !== null ? roundOffStock(item?.tax_amount) : ""),
                skip_item:0,
                po_qty: roundOffStock(item.po_qty),
                qty: roundOffStock(item.qty),
                rate: roundOffStock(item.rate),
                amount: roundOffStock(item.amount),
                total: roundOffStock(item.total),
                base_qty: roundOffStock(item.base_qty),
                conversion_qty: roundOffStock(item.conversion_qty),
                base_price: roundOffStock(item.base_price),
                isEdit: true,
              })
            })
            setNewRow([...rowArr]);
          }
        }
      }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && supplierForSearch) {
      getPurchasedItem()
    }
  }, [id, supplierForSearch]);

  const handleChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  //on change input field
  const handleDesc = (e) => {
    setNewItem({ ...newItem, description: e.target.value });
  };

  //set items hook
  const handleSetItems = async (index, item) => {
    newRow[index].unit = "";
    newRow[index].base_unit = "";
    newRow[index].base_qty = "";
    newRow[index].conversion_qty = "";
    // console.log("check item==>",item);
    newRow[index].item_name = item;
    newRow[index].base_unit = item.unit_id;
    newRow[index].item_units = "";
    setNewRow([...newRow]);
    const url = BASE_URL + "/settings/get-unit_item/" + item.id;
    await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (res.data) {
          newRow[index].item_units = res.data;
          newRow[index].unit = res.data[1];
          newRow[index].conversion_qty = roundOffStock(res.data[1].qty);
          setNewRow([...newRow]);
        }
      }).catch((error) => {
        console.log("check error", error);
      })
  };

  //handle unit
  const handleSetUnit = (index, unit) => {
    newRow[index].unit = unit;
    newRow[index].conversion_qty = roundOffStock(unit.qty);
    setNewRow([...newRow]);
  }

  //subtotal
  const handleGetAmount = (slug) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[slug].qty) {
      qty = parseFloat(newRow[slug].qty);
    }
    if (newRow !== null && newRow[slug].rate) {
      rate = parseFloat(newRow[slug].rate);
    }
    return roundOffStock(rate * qty)
  };

  //subtotal
  const handleGetSubTotal = (slug) => {
    let qty = 0;
    let rate = 0;

    if (newRow !== null && newRow[slug]?.qty) {
      qty = parseFloat(newRow[slug].qty);
    }
    if (newRow !== null && newRow[slug]?.rate) {
      rate = parseFloat(newRow[slug].rate);
    }
    let taxAmount = parseFloat(handleTaxItem(slug) || 0);
    return roundOffStock(rate * qty + taxAmount);
  };

  const handleTaxItem = (slug) => {
    let tax = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[slug]?.qty) {
      qty = parseFloat(newRow[slug].qty);
    }

    if (newRow !== null && newRow[slug]?.tax_percent !== undefined && newRow[slug]?.tax_percent !== null && newRow[slug]?.tax_percent !== "") {
      tax = parseFloat(newRow[slug].tax_percent);
    } else if (newRow !== null && newRow[slug]?.tax !== undefined && newRow[slug]?.tax !== null && newRow[slug]?.tax !== "") {
      return roundOffStock(parseFloat(newRow[slug].tax));
    }

    if (newRow !== null && newRow[slug]?.rate) {
      rate = parseFloat(newRow[slug].rate);
    }
    return roundOffStock((rate * qty * (tax / 100)));

  };

  const handleDiscountItem = (slug) => {
    let discount = 0;
    let rate = 0;
    let qty = 0;

    if (newRow !== null && newRow[slug].qty) {
      qty = parseFloat(newRow[slug].qty);
    }

    if (newRow !== null && newRow[slug].discount_percent) {
      discount = parseFloat(newRow[slug].discount_percent);
    }
    if (newRow !== null && newRow[slug].rate) {
      rate = parseFloat(newRow[slug].rate);
    }

    return roundOffStock(rate * qty * (discount / 100));
  };


  const handleDisAmount = () => {
    let discount = 0;
    if (newRow !== null && newRow.length > 0) {
      newRow.map((item) => {
        if (item.discount_percent !== null && item.item_discount !== "") {
          discount = discount + item.rate * item.qty * (item.discount_percent / 100);
        }
      });
    }
    return roundOffStock(discount);
  };

  const handleTaxAmount = () => {
    let tax = 0;
    if (newRow !== null && newRow.length > 0) {
      newRow.forEach((item, index) => {
        if (item.skip_item !== 1) {
          tax = tax + parseFloat(handleTaxItem(index) || 0);
        }
      });
    }
    return roundOffStock(tax);
  };

  // total amount
  const handleAmount = () => {
    let total = 0;
    if (newRow !== null && newRow.length > 0) {
      newRow.forEach((item) => {
        if (
          item.skip_item !== 1 &&
          parseFloat(item.qty) &&
          parseFloat(item.rate)
        ) {
          total = total + parseFloat(item.qty) * parseFloat(item.rate);
        }
      });
    }
    return roundOffStock(total);
  };

  //total
  const handleGetTotal = () => {
    let total = 0;
    if (newRow !== null && newRow.length > 0) {
      newRow.forEach((item, index) => {
        if (item.skip_item !== 1) {
          total = total + parseFloat(handleGetSubTotal(index) || 0);
        }
      });
    }
    return roundOffStock(total);
  };

  const calBasePrice = (index) => {
    let amount = handleGetAmount(index);
    let baseQty = calBaseQty(index);
    if (amount && baseQty) {
      return roundOffStock(amount / baseQty);
    } else {
      return 0;
    }
  }

  //set each item qty
  const handleItemQty = (index, e) => {
    newRow[index].qty = e.target.value;
    if(e.target.value && Number(e.target.value) > 0){
      newRow[index].skip_item = 0;
    }
    setNewRow([...newRow]);
  };

  const handleItemSkip = (index) => {
    newRow[index].skip_item = newRow[index].skip_item ? 0 : 1;
    setNewRow([...newRow]);
  };

  //set each item qty
  const handleItemRate = (index, e) => {
    newRow[index].rate = e.target.value;
    setNewRow([...newRow]);
  };

  //set each item qty
  const handleTax = (index, e) => {
    newRow[index].tax_percent = e.target.value;
    setNewRow([...newRow]);
  };

  //set each item qty
  const handleDiscount = (index, e) => {
    newRow[index].discount_percent = e.target.value;
    setNewRow([...newRow]);
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewItem({ ...newItem, branch, purchase_order: null, });
    if (newItem.is_ref_no && branch) {
      handlePurchaseOrder(branch.id)
    }
  };

  const handleCheckRef = () => {
    setNewItem({ ...newItem, is_ref_no: newItem.is_ref_no ? 0 : 1 })
    if (!newItem.is_ref_no) {
      setNewRow([]);
      if (newItem.branch) {
        handlePurchaseOrder(newItem.branch.id)
      }
    }
  }

  //get supplier items
  const getIngredientSupplier = async (id) => {
    const url = BASE_URL + "/settings/edit-supplier/" + id
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      return res.data;
    } catch (err) {
      toast.error(
        `${_t(t("Failed to fetch supplier items"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  //handle Set supplier hook
  const handleSetSupplier = async (supplier) => {
    setNewItem({ ...newItem, supplier });
    if (newItem.is_ref_no === 0) {
      const supplierItems = await getIngredientSupplier(supplier?.id);
      if (supplierItems?.ingredient_items && supplierItems.ingredient_items?.length) {
        const items = supplierItems.ingredient_items.map((item, index) => {
          const units = [item.base_unit, item.default_unit];
          return {
            id: index,
            item_name: item,
            po_qty: "",
            qty: "",
            unit: "",
            item_units: units,
            rate: item?.price ?? "",
            base_unit: item?.unit_id,
            skip_item: 0,
            tax: item?.tax !== undefined && item?.tax !== null ? roundOffStock(item.tax) : "",
            tax_percent: item?.tax_percent !== undefined && item?.tax_percent !== null ? roundOffStock(item.tax_percent) : "",
            base_qty: "",
            conversion_qty: ""
          }
        });
        setNewRow([...items]);
      } else if (newRow?.length) {
        setNewRow([]);
      }
    }
  };

  const ingredientItemAxios = async () => {
    let date =
      new Date(newItem.date).getFullYear() +
      "-" +
      (new Date(newItem.date).getMonth() + 1) +
      "-" +
      new Date(newItem.date).getDate();
    let duplicate = {};
    const duplicateItem = [];
    let slugArray = [];
    newRow.map((newIngredientItem, index) => {
      if (duplicate[newIngredientItem?.item_id || newIngredientItem.item_name.id]) {
        duplicateItem.push({
          item_id: newIngredientItem?.item_id || newIngredientItem.item_name.id,
          item_name: newIngredientItem.item_name?.name || newIngredientItem.item_name,
        })
      }
      if (newIngredientItem.item_name === "" || newIngredientItem.unit === "") {
        slugArray.push();
      } else {
        duplicate[newIngredientItem?.item_id || newIngredientItem.item_name.id] = true;
        slugArray.push({
          skip_item: newIngredientItem?.skip_item ?? 0,
          id: newIngredientItem?.id,
          po_detail_id: newIngredientItem?.po_detail_id || 0,
          po_qty: newIngredientItem?.po_qty,
          qty: parseFloat(newIngredientItem.qty),
          price: parseFloat(newIngredientItem.rate),
          item_id: newIngredientItem.isEdit ? newIngredientItem.item_id : newIngredientItem.item_name.id,
          item_name: newIngredientItem.isEdit ? newIngredientItem.item_name : newIngredientItem.item_name.name,
          unit_id: newIngredientItem.isEdit ? newIngredientItem.unit_id : newIngredientItem.unit.id,
          unit_name: newIngredientItem.isEdit ? newIngredientItem.unit_name : newIngredientItem.unit.name,
          amount: handleGetAmount(index),
          tax_percent: newIngredientItem?.tax_percent !== undefined && newIngredientItem?.tax_percent !== null && newIngredientItem?.tax_percent !== "" ? parseFloat(newIngredientItem.tax_percent) : 0,
          tax: handleTaxItem(index),
          total: handleGetSubTotal(index),
          base_unit: newIngredientItem.base_unit,
          base_qty: calBaseQty(index),
          base_price: calBasePrice(index),
          conversion_qty: parseFloat(newIngredientItem.conversion_qty)
        });
      }
    });

    if (duplicateItem?.length) {
      toast.error(`${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    let formData = {
      branch_id: newItem.branch.id,
      branch_name: newItem.branch.name,
      supplier_id: newItem.supplier?.id ?? "",
      supplier_name: newItem.supplier?.name ?? "",
      goods_date: date,
      manual_invoice_no: newItem?.manual_invoice_no ?? "",
      purchase_order_id: newItem.purchase_order?.document_identity || "",
      desc: newItem.description,
      items: slugArray,
      total_bill: handleGetTotal(),
      total_amount: handleAmount(),
      total_tax: handleTaxAmount(),
      // total_discount: handleDisAmount(),
    };

    if (newRow.length === slugArray.length) {
      setLoading(true);
      const endPoint = id ? ("/settings/goods-received-note/" + id) : "/settings/goods-received-note";
      const url = BASE_URL + endPoint;
      const method = id ? "put" : "post";
      try {
        const res = await axios[method](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if (res.data) {
          setLoading(false);
          toast.success(`${_t(t(id ? "Grn Notes has been updated" : "Grn Notes has been added"))}`, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          history.push("/dashboard/manage/stock/goods-received-note")
        }
      } catch (error) {
        setLoading(false);
        if(error.response.data.status === 0){
          toast.error(error.response.data.message ,toastObj)
          return false;
        }
        toast.error(`${_t(t("Please try again later"))}`, toastObj);
      }
    } else {
      toast.error(`${_t(t("Please select all dropdowns"))}`, toastObj);
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newItem.branch !== null &&
      newItem.date !== null
    ) {
      if (newRow.length > 0) {
        ingredientItemAxios();
      }
      else {
        toast.error(`${_t(t("Please add notes"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } else {
      toast.error(`${_t(t("Please fill all the required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  const calBaseQty = (index) => {
    let qty = newRow[index].qty;
    let conversion_qty = newRow[index].conversion_qty
    if (qty && conversion_qty) {
      return roundOffStock(qty * conversion_qty);
    } else {
      return "";
    }
  }

  const addNewRow = () => {
    // if(newOpeningStock.branch !== null){
    setNewRow((pre) => [...pre, {
      item_name: "",
      po_qty: "",
      qty: "",
      unit: "",
      item_units: "",
      rate: 0,
      skip_item: 0,
      tax_percent: "",
      tax: "",
      base_unit: "",
      base_qty: "",
      conversion_qty: ""
    }])
  }

  const delRow = (id) => {
    let row = [...newRow]
    row.splice(id, 1);
    setNewRow(row);
  }

  return (
    <>
      <Helmet>
        <title>{_t(t(id ? "Edit Good Recieved Note" : "Good Recieved Note"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${dataPaginating && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t(id ? "Edit Good Recieved Note" : "Add Good Recieved Note"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center"></div>
                          </div>
                        </div>

                        {/* Form starts here */}
                        <form
                          className="row card p-2 mx-3 mb-5 table-text"
                          onSubmit={handleSubmit}
                          autoComplete="off"
                        >
                          <div className="col-12">
                            <div className="row">

                              <div className="row">
                                <div className="form-group col-4 mt-3">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="invoice"
                                      className="control-label"
                                    >
                                      {_t(t("GRN #"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <input
                                      type="text"
                                      readOnly
                                      className="form-control table-text"
                                      id="invoice"
                                      name="invoice"
                                      value={newItem.gr_no}
                                      placeholder="Auto no"
                                      required
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-3 text-right mt-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="goodsDate"
                                      className="control-label"
                                    >
                                      {_t(t("GRN Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      disabled
                                      selected={newItem.date}
                                      onChange={(date) => setNewItem({ ...newItem, date })}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("GR date"))}
                                      shouldCloseOnSelect={false}
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-1 text-right mt-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="is_ref_no"
                                      className="control-label"
                                    >
                                      {_t(t("Ref No."))}
                                    </label>
                                  </div>
                                  <div className="mb-2 float-left">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="is_ref_no"
                                      name="is_ref_no"
                                      onChange={() => handleCheckRef()}
                                      checked={newItem.is_ref_no}
                                      disabled={id}
                                    />
                                  </div>
                                </div>

                                <div className="form-group mt-3 col-4">
                                  <div className="mb-1 text-left">
                                    <label
                                      htmlFor="branch"
                                      className="control-label text-truncate"
                                    >
                                      {_t(t("Branch"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <Select
                                    options={branchForSearch || []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newItem.branch || ""}
                                    isDisabled={id}
                                    classNamePrefix="select"
                                    onChange={handleSetBranch}
                                    maxMenuHeight="200px"
                                    placeholder={
                                      _t(t("Please select a branch")) + ".."
                                    }
                                    styles={customStyle}
                                    required
                                  />
                                </div>
                              </div>

                            </div>
                            <div className="row w-100">
                              <div className="form-group mt-3 col-3">
                                <div className="mb-2 text-left">
                                  <label
                                    htmlFor="supplier"
                                    className="control-label"
                                  >
                                    {_t(t("Supplier/Vendor"))}
                                  </label>
                                </div>
                                <Select
                                  options={supplierForSearch}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.name}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.supplier || ""}
                                  isDisabled={id}
                                  classNamePrefix="select table-text"
                                  onChange={handleSetSupplier}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(t("Please select a supplier")) + ".."
                                  }
                                  styles={customStyle}
                                />
                              </div>
                              <div className="form-group mt-3 col-2">
                                <div className="mb-2">
                                  <label
                                    htmlFor="manual_inv_no"
                                    className="control-label"
                                  >
                                    {_t(t("Manual Invoice No"))}
                                  </label>
                                </div>

                                <input
                                  type="text"
                                  className="form-control table-text"
                                  id="manual_inv_no"
                                  name="manual_invoice_no"
                                  onChange={handleChange}
                                  value={newItem.manual_invoice_no}
                                  placeholder="Invoice no"
                                />
                              </div>
                              <div className="form-group mt-3 col-3">
                                <div className="mb-2 text-left">
                                  <label
                                    className="control-label"
                                  >
                                    {_t(t("Purchase Order No"))}
                                  </label>
                                </div>
                                <Select
                                  options={purchaseOrders || []}
                                  components={makeAnimated()}
                                  getOptionLabel={(option) => option.document_identity}
                                  getOptionValue={(option) => option.id}
                                  value={newItem.purchase_order || ""}
                                  classNamePrefix="select table-text"
                                  isClearable
                                  onChange={(option) => setPurchaseOrderItem(option)}
                                  maxMenuHeight="200px"
                                  placeholder={
                                    _t(t("Please select purchase")) + ".."
                                  }
                                  styles={customStyle}
                                  isDisabled={dataPaginating || !newItem.branch || !newItem.is_ref_no || id}
                                />
                              </div>
                              <div className="form-group mt-3 col-4">
                                <div className="mb-2">
                                  <label
                                    htmlFor="description"
                                    className="control-label"
                                  >
                                    {_t(t("Description"))}
                                  </label>
                                </div>
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    className="form-control table-text"
                                    id="description"
                                    name="description"
                                    onChange={handleDesc}
                                    value={newItem.description}
                                    placeholder="Short description"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="table-responsive mt-3 pr-1" style={{ maxHeight: "23rem", overflow: "auto" }}>
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                    {newRow.length == 0 ? <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={() => addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                      </span>
                                    </th> : <th style={{ borderBottomColor: "lightgray" }}></th>}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "12rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Name"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Po Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "12rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Unit"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Rate"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Amount"))}
                                      </span>
                                    </th>

                                    {/* <th
                                  scope="col"
                                  className="table-text text-capitalize align-middle text-center border-1 border"
                                  style={{minWidth:"170px"}}
                                >
                                  <span style={{fontWeight:500}}>
                                  {_t(t("Discount Percent"))}
                                  </span>
                                </th>

                                <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                                  >
                                  <span style={{fontWeight:500}}>
                                  {_t(t("Discount"))}
                                  </span>
                                </th>
                                  
                                <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  <span style={{fontWeight:500}}>
                                  {_t(t("Tax Percent"))}
                                  </span>
                                </th>

                                <th
                                scope="col"
                                className="table-text text-capitalize align-middle text-center border-1 border"
                                >
                                  <span style={{fontWeight:500}}>
                                  {_t(t("Tax"))}
                                  </span>
                                </th> */}

                                    {/* <th
                                      scope="col-2"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Total"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Base unit"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Base qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "9rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Conversion unit"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{ minWidth: "9rem" }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        {_t(t("Base price"))}
                                      </span>
                                    </th> */}
                                    {newRow.length > 0 && <th style={{ borderBottomColor: "lightgray", minWidth: "60px" }}></th>}
                                  </tr>
                                </thead>
                                {newRow && newRow.length > 0 ?
                                  <tbody className="align-middle">
                                    {
                                      newRow?.map(
                                        (ingredientItem, index) => {
                                          return (
                                            <tr
                                              className="align-middle"
                                              key={index}
                                            >
                                              <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{ minWidth: "60px" }}>
                                                {index == (newRow.length - 1) && <span className="t-mr-10" onClick={() => addNewRow()}>
                                                  <i className="fa fa-plus-circle btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                                </span>}&nbsp;
                                                <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }}
                                                  onClick={() => { delRow(index) }}
                                                ></i>
                                              </td>
                                              <td className="d-flex align-items-center table-text text-capitalize align-middle text-center table-Child">
                                                {
                                                  newItem.purchase_order ? (
                                                    <div className="float-left mr-2">
                                                      <input
                                                        title="po item close"
                                                        disabled={ingredientItem.qty && Number(ingredientItem.qty) > 0}
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`skip_${index}`}
                                                        name="skip"
                                                        onChange={() => handleItemSkip(index)}
                                                        checked={ingredientItem.skip_item}
                                                      />
                                                    </div>
                                                  ) : ""
                                                }
                                                {ingredientItem?.isEdit ?
                                                  <input
                                                    readOnly
                                                    type="text"
                                                    className={`form-control text-center table-Input table-text`}
                                                    value={ingredientItem.item_name || ""}
                                                  />
                                                  :
                                                  <Select
                                                    menuPosition="fixed"
                                                    options={ingredientItemNonPurchase}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.id}
                                                    classNamePrefix="select table-text"
                                                    className="w-100"
                                                    onChange={(e) => handleSetItems(index, e)}
                                                    value={ingredientItem.item_name}
                                                    placeholder={
                                                      _t(t("Please select items")) + ".."
                                                    }
                                                    styles={customStyle}
                                                  />
                                                }
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center" style={{ width: "15%" }}>
                                                <input
                                                  type="number"
                                                  readOnly
                                                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                  className="form-control text-center table-Input table-text"
                                                  id={ingredientItem.id}
                                                  name={ingredientItem.id}
                                                  value={ingredientItem.po_qty ? ingredientItem.po_qty : ""}
                                                />
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center" style={{ width: "15%" }}>
                                                <input
                                                  type="number"
                                                  step={qtyAmountPoints()}
                                                  min="0"
                                                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                  className="form-control text-center table-Input table-text"
                                                  id={ingredientItem.id}
                                                  name={ingredientItem.id}
                                                  onChange={(e) => handleItemQty(index, e)}
                                                  value={ingredientItem.qty ? ingredientItem.qty : ""}
                                                  placeholder="Qty"
                                                  max={(parseInt(getSystemSettings(generalSettings, "allow_access_quantity")) === 0 && newItem.purchase_order && ingredientItem.po_qty) ? Number(ingredientItem.po_qty) : undefined}
                                                  required
                                                />
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                {ingredientItem?.isEdit ?
                                                  <input
                                                    readOnly
                                                    type="text"
                                                    className={`form-control text-center table-Input table-text`}
                                                    value={ingredientItem.unit_name || ""}
                                                  />
                                                  :
                                                  <Select
                                                    menuPosition="fixed"
                                                    options={ingredientItem.item_units ? ingredientItem.item_units : []}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.id}
                                                    value={ingredientItem.unit}
                                                    classNamePrefix="select"
                                                    onChange={(e) => handleSetUnit(index, e)}
                                                    styles={customStyle}
                                                    placeholder={
                                                      _t(t("please select unit")) + ".."
                                                    }
                                                    isDisabled={ingredientItem.item_units ? false : true}
                                                  />
                                                }
                                              </td>
                                              <td className="table-text text-capitalize align-middle text-center" style={{ width: "15%" }}>
                                                <input
                                                  disabled={newItem.purchase_order}
                                                  type="number"
                                                  step={qtyAmountPoints()}
                                                  min="0"
                                                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                  className="form-control text-center table-Input table-text"
                                                  id={ingredientItem.id}
                                                  name={ingredientItem.id}
                                                  onChange={(e) => handleItemRate(index, e)}
                                                  value={ingredientItem.rate ?? ""}
                                                  placeholder="Price"
                                                  required
                                                />
                                              </td>

                                              <td className="table-text align-middle text-center">
                                                {formatPrice(
                                                  handleGetAmount(index)
                                                )}
                                              </td>
                                              
                                               {/* hidden columns */}

                                              {/* <td className="table-text text-capitalize align-middle text-center">
                                                <input
                                                  type="number"
                                                  step={qtyAmountPoints()}
                                                  min="0"
                                                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                  className={`form-control text-center table-Input table-text`}
                                                  id={ingredientItem.id}
                                                  name={ingredientItem.id}
                                                  onChange={(e) => handleDiscount(index, e)}
                                                  value={ingredientItem.discount_percent}
                                                  placeholder="Discount"
                                                // required

                                                />
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                {formatPrice(handleDiscountItem(index))}
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                <input
                                                  type="number"
                                                  step={qtyAmountPoints()}
                                                  min="0"
                                                  onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                                  className={`form-control text-center table-Input table-text`}
                                                  id={ingredientItem.id}
                                                  name={ingredientItem.id}
                                                  onChange={(e) => handleTax(index, e)}
                                                  value={ingredientItem.tax_percent}
                                                  placeholder="Tax"
                                                // required
                                                />
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                {formatPrice(
                                                  handleTaxItem(index)
                                                )}
                                              </td>

                                              <td className="table-text text-capitalize align-middle text-center">
                                                {formatPrice(
                                                  handleGetSubTotal(index)
                                                )}
                                              </td>

                                              <td className="table-text align-middle text-center">
                                                {ingredientItem.base_unit}
                                              </td>

                                              <td className="table-text align-middle text-center">
                                                {formatPrice(calBaseQty(index))}
                                              </td>

                                              <td className="table-text align-middle text-center">
                                                {ingredientItem.conversion_qty}
                                              </td>

                                              <td className="table-text align-middle text-center">
                                                {formatPrice(calBasePrice(index))}
                                              </td> */}

                                              <td className="table-text text-capitalize align-middle text-center" style={{ minWidth: "60px" }}>
                                                <i className="fa fa-minus-circle cursor-pointer text-danger" style={{ fontSize: "22px" }} onClick={() => { delRow(index) }}></i>&nbsp;
                                                {index == (newRow.length - 1) && <span className="t-mr-10" onClick={() => addNewRow()}>
                                                  <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{ fontSize: "22px" }} aria-hidden="true"></i>
                                                </span>}
                                              </td>

                                            </tr>
                                          );
                                        }
                                      )}
                                  </tbody>
                                  : null}
                                {newRow && newRow.length > 0 ?
                                  <tfoot className="align-middle">
                                    <tr>
                                      <th
                                        style={{ minWidth: "100px" }}
                                        scope="col"
                                        colSpan="5"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      ></th>

                                      <th
                                        style={{ minWidth: "100px" }}
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{ fontWeight: "bold" }}>
                                          {_t(t("Total"))}
                                        </span>
                                      </th>

                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <span style={{ fontWeight: "bold" }}>
                                          {formatPrice(handleAmount())}
                                        </span>
                                      </th>
                                        {/* <th
                                          scope="col"
                                        >
                                        </th>
                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            {formatPrice(handleDisAmount())}
                                          </span>
                                        </th>
                                        <th
                                          scope="col"
                                        >
                                        </th>
                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            {formatPrice(handleTaxAmount())}
                                          </span>
                                        </th>
                                        <th
                                          scope="col"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        >
                                          <span style={{ fontWeight: "bold" }}>
                                            {formatPrice(handleGetTotal())}
                                          </span>
                                        </th>
                                        <th
                                          style={{ minWidth: "100px" }}
                                          scope="col"
                                          colSpan="5"
                                          className="table-text text-capitalize align-middle text-center border-1 border"
                                        ></th> */}
                                    </tr>

                                  </tfoot>
                                  : null}
                              </table>
                            </div>
                            <div className="form-group mt-4 pb-2">
                              <div className="d-flex justify-content-end align-items-center">
                                <div className="col-3 d-flex justify-content-end">
                                  <button
                                    type="button"
                                    className="btn rounded hov-btn mr-3"
                                    onClick={() => (history.push("/dashboard/manage/stock/goods-received-note"))}
                                  //   data-dismiss="modal"
                                  >
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                  </button>
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded"
                                  >
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  )
}

export default GoodsReceivedNote
